import { useEffect } from "react";

// Dedicated OAuth callback page for Instagram popup flow.
// BroadcastChannel is used instead of postMessage because Instagram nulls
// out window.opener during cross-origin OAuth redirects for security,
// making postMessage unreachable from the callback page.
const InstagramCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const userId = params.get("user_id");
    const error = params.get("error");
    const errorDescription = params.get("error_description");

    const bc = new BroadcastChannel("instagram-oauth");
    bc.postMessage({ token, userId, error, errorDescription });
    bc.close();
    // Do NOT call window.close() here. The parent closes the popup via
    // popup.close() inside bc.onmessage. If the popup closes itself first,
    // popup.closed can become true before bc.onmessage fires, causing the
    // setInterval guard to race and reject with "User closed the window".
  }, []);

  return null;
};

export default InstagramCallback;
